import React from 'react'
import { useIntl } from 'react-intl'

import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import HeadingFullPrint from 'tripPlanner/components/util/HeadingFullPrint'
import { useAirport } from 'tripPlanner/hooks/api/flights'
import type { FlightItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: FlightItem
}

function getAirportName(
  airport: App.AirportLocation | undefined,
  placeName: string,
) {
  let airportName: string | undefined

  if (airport) {
    airportName =
      airport.airportName || airport.cityAirportName || airport.cityDesc
  }
  // Fallback if no airport or if it's missing data
  if (!airportName) {
    airportName = placeName
  }
  return airportName
}

function FlightItemCardHeading(props: Props) {
  const intl = useIntl()
  const { item } = props

  const { data: departureAirport } = useAirport({
    code: item.originAirportCode,
  })

  const { data: arrivalAirport } = useAirport({
    code: item.destinationAirportCode,
  })

  const hasAirports = !!(departureAirport && arrivalAirport)
  const departureAirportName = getAirportName(
    departureAirport,
    item.startPlace.name,
  )
  const arrivalAirportName = getAirportName(arrivalAirport, item.endPlace.name)

  return (
    <HeadingFullPrint variant="heading6">
      {!hasAirports && <TextLoadingBox width={160} />}
      {hasAirports && intl.formatMessage(
        {
          id: 'vo5xzjanMP',
          defaultMessage: '{origin} to {destination}',
          description: 'Flight route heading showing departure to arrival airport names',
        },
        { origin: departureAirportName, destination: arrivalAirportName },
      )}
    </HeadingFullPrint>
  )
}

export default FlightItemCardHeading
